import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListNumbers24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconListNumbers24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.006 5v5.34a.75.75 0 0 1-1.5 0V6.88l-.66.15a.75.75 0 0 1-.332-1.463l1.576-.358zm-.812 9.008a1 1 0 0 0-.814.445.75.75 0 0 1-1.26-.815c.333-.514 1.051-1.13 2.074-1.13.426 0 .888.136 1.25.476.373.35.565.845.565 1.415 0 .966-.486 1.876-1.02 2.597q-.193.259-.402.501h1.165a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.48-1.325c.481-.403 1.061-.96 1.514-1.57.465-.627.725-1.217.725-1.703 0-.225-.068-.3-.091-.322-.034-.032-.105-.069-.224-.069M22.075 6.75a.75.75 0 0 1-.75.75h-10.52a.75.75 0 0 1 0-1.5h10.52a.75.75 0 0 1 .75.75m-2.428 3.5a.75.75 0 0 1-.75.75h-8.093a.75.75 0 0 1 0-1.5h8.093a.75.75 0 0 1 .75.75m1.678 4.25a.75.75 0 0 0 0-1.5h-10.52a.75.75 0 0 0 0 1.5zm-1.678 2.75a.75.75 0 0 1-.75.75h-8.093a.75.75 0 0 1 0-1.5h8.093a.75.75 0 0 1 .75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListNumbers24);
